export default __webpack_public_path__ + "static/media/2223 knife block B side.e4606814.png";